import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Container,
  List,
  ListItem,
  useColorMode,
} from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const ForColumn = ({ title, bullets, featured, colorMode }) => {
  return (
    <Box
      bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
      borderRadius="lg"
      p={{ base: 6, md: featured ? 12 : 8 }}
      border="1px solid"
      borderColor={
        featured
          ? "blueC.100"
          : getCurrentColor(colorMode, "grayC.500", "grayC.2000")
      }
      boxShadow={featured ? "0 0 0 2px var(--chakra-colors-blueC-100)" : "none"}
      transform={{ md: featured ? "scale(1.05)" : "scale(1)" }}
      transition="all 0.2s"
    >
      <Heading
        as="h3"
        fontSize={{ base: "xl", md: featured ? "3xl" : "2xl" }}
        fontWeight="700"
        color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
        mb={6}
      >
        {title}
      </Heading>
      <List spacing={4}>
        {bullets.map((bullet, idx) => (
          <ListItem key={idx} display="flex" alignItems="start" gap={3}>
            <Text
              as="span"
              color={"blueC.100"}
              fontWeight="700"
              flexShrink={0}
              mt="2px"
            >
              •
            </Text>
            <Text
              color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
              fontSize={{ base: "sm", md: "md" }}
              lineHeight="snug"
            >
              {bullet}
            </Text>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const ShotShowWhoIsForSection = () => {
  const { colorMode } = useColorMode();

  const columns = [
    {
      title: "Retailers",
      bullets: [
        "Get visibility where price-aware shooters start their search",
        "Drive qualified traffic directly to product pages",
        "Compete on true delivered pricing, not gimmicks",
        "No inventory risk or fulfillment involvement",
      ],
    },
    {
      title: "Shoppers (Shooters)",
      bullets: [
        "See shipping-included cost per round up front",
        "Avoid misleadingly low prices with high shipping",
        "Compare many retailers in one search",
        "Save time and money on every ammo purchase",
        "Always free — no signup or membership required",
      ],
      featured: true,
    },
    {
      title: "Manufacturers & Brands",
      bullets: [
        "Unmatched visibility into market pricing and availability across the retail ecosystem",
        "Actionable demand intelligence based on real shooter search behavior",
        "Brand-safe promotional opportunities including rebate highlights and product discovery",
        "Live SKU-level availability feeds that help shoppers already looking for your products find in-stock retailers with one click",
      ],
    },
  ];

  return (
    <Box
      bg={getCurrentColor(colorMode, "whiteC.200", "blueC.500")}
      py={{ base: "64px", md: "80px" }}
      borderTop="1px solid"
      borderColor={getCurrentColor(colorMode, "grayC.500", "grayC.2000")}
    >
      <Container maxW="7xl">
        <Heading
          as="h2"
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight="700"
          color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
          mb={12}
          textAlign="center"
          lineHeight="tight"
        >
          Who BulletScout Is For
        </Heading>

        <SimpleGrid
          columns={{ base: 1, md: 3 }}
          spacing={6}
          alignItems="center"
        >
          {columns.map((col, idx) => (
            <ForColumn key={idx} {...col} colorMode={colorMode} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default ShotShowWhoIsForSection;